//Home.js
import React from "react";
import Layout from "../components/layout";
import { useSelector } from "react-redux";

const Home = () => {
  const { userRole } = useSelector((state) => state.role);
  const { userId } = useSelector((state) => state.user);

  return (
    <div>
      <Layout>
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          {/* show console.log user role */}
          <p>Benutzerrolle: {userRole}</p>
          <br />
          {/* show console.log user id */}
          <p>Benutzer-ID: {userId}</p>

        </div>
      </Layout>
    </div>
  );
};

export default Home;
